import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import DealSummaryItem from '../common/DealSummaryItem';
import { ZERO_DOLLARS } from '../../constants';
import LineItemWithChildren from '../common/LineItemWithChildren';
import { getLabelNodeStyles, getValueByUnit } from '../utils/transform';
import { expandibleButtonStyles, expandibleAreaStyles, nestedValueNodeStyles, nestedLabelNodeStyles } from '../utils/styles';

interface BackendProfitItemProps {
    item: Record<string, string | Record<string, string>[]>;
    index: number;
    showDetailedView: boolean;
    valueStyles: React.CSSProperties;
    backendProfitDetails: Record<string, any>;
    reserve?: Record<string, any>;
}
const BackendProfitItem: React.FC<BackendProfitItemProps> = (props) => {
    const { item, index, showDetailedView, valueStyles, backendProfitDetails, reserve } = props;
    const hasItemizedData = Array.isArray(item.children) && item.children.length > 0;
    return (
        <DealSummaryItem
            key={`${item.label}-${index}`}
            valueStyles={valueStyles}
            labelStyles={getLabelNodeStyles(showDetailedView, hasItemizedData)}
            expandibleButtonStyles={expandibleButtonStyles}
            expandibleAreaStyles={{ ...expandibleAreaStyles }}
            label={String(item.label)}
            value={formatDollarsAndCents(backendProfitDetails[item.value as keyof typeof backendProfitDetails], ZERO_DOLLARS)}
        >
            {hasItemizedData &&
                (item.children as Record<string, string>[]).map((child, childIndex) => (
                    <LineItemWithChildren
                        key={`${index}-${child.label}-${childIndex}`}
                        valueStyles={nestedValueNodeStyles}
                        labelStyles={nestedLabelNodeStyles}
                        label={child.label}
                        value={getValueByUnit(reserve?.[child.value], child.unit)}
                    />
                ))}
        </DealSummaryItem>
    );
};

export default BackendProfitItem;
